<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline primary--text">
          {{ $t("screener.consumer.profile.title") }}
        </div>
        <span class="body-1 secondary--text">
          {{ $t("screener.consumer.profile.subtitle") }}</span
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!is_editing"
        color="primary background--text"
        dark
        @click="is_editing = !is_editing"
        class="ma-0"
      >
        <v-icon small>$vuetify.icons.rms_edit</v-icon>
        &nbsp;{{ $t("rms.button.edit") }}
      </v-btn>
      <v-btn v-else color="primary background--text" dark @click="save()" class="ma-0">
        <v-icon small>$vuetify.icons.rms_save</v-icon>
        &nbsp;{{ $t("rms.button.save") }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-card>
        <v-card-text>
          <v-layout row wrap py-3>
            <v-flex xs12 sm4 md3 lg3>
              <v-layout justify-center align-center pb-3>
                <avatar :size="150" :username="consumer_name ? consumer_name : consumer_email"></avatar>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm8 md9 lg9>
              <v-form ref="form" onsubmit="return false;">
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="headline primary--text">
                      <span>{{ consumer_email }}</span>
                    </div>
                    <v-divider class="mt-2 mb-4"></v-divider>
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                    :class="
                      $vuetify.breakpoint.width > 959
                        ? !$vuetify.rtl
                          ? 'pr-2'
                          : 'pl-2'
                        : ''
                    "
                  >
                    <!-- Name -->
                    <v-text-field
                      outline
                      :disabled="!is_editing"
                      v-model="consumer_name"
                      label="Name"
                      color="secondary"
                      :rules="[
                        rules.required,
                        rules.min_length(3),
                        rules.max_length(250),
                      ]"
                      counter="250"
                    ></v-text-field
                  ></v-flex>
                  <v-flex
                    xs12
                    md6
                    :class="
                      $vuetify.breakpoint.width > 959
                        ? !$vuetify.rtl
                          ? 'pl-2'
                          : 'pr-2'
                        : ''
                    "
                  >
                    <!-- City -->
                    <v-text-field
                      outline
                      :disabled="!is_editing"
                      v-model="consumer_city"
                      label="City"
                      color="secondary"
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs12>
                    <!-- Phone -->
                    <div class="pb-3">
                      <VuePhoneNumberInput
                        :disabled="!is_editing"
                        class="custom-input"
                        @update="setPhoneNumber"
                        :no-example="true"
                        :translations="Optionaltranslations"
                        :show-code-on-list="true"
                        :countries-height="30"
                        :default-country-code="country_code"
                        v-model="consumerPhone"
                        :value="consumerPhone"
                        size="lg"
                        :dark="darkMode"
                      />
                      <div
                        class="caption py-2 secondary--text text--lighten-2"
                        v-html="$t('screener.consumer.profile.phone.tip')"
                      ></div>
                    </div>
                  </v-flex>
                  <!-- Change Password -->
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 md10>
                        <div class="d-inline-block">
                          <div class="title pb-1 primary--text">{{$t('screener.change_password.label')}}</div>
                          <div class="subheading secondary--text">{{$t('screener.change_password.subtitle')}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs12 md2 class="text-md-right">
                        <a @click="passworddialog = true" class="subheading primary--text" ><h4>{{$t('screener.btn.change')}}</h4></a>
                      </v-flex>
                    </v-layout>
                     <v-dialog
                      v-model="passworddialog"
                      width="500px"
                      flat
                      scrollable
                      @input="reset"
                    >
                      <v-card class="pa-2" flat style="overflow: auto; height: 100%">
                        <v-card-title class="headline">{{$t('screener.change_password.label')}}</v-card-title>
                        <v-card-text>
                          <ChangePassword
                            :password.sync="password"
                            :confirm_password.sync="confirm_password"
                            ref="changePasswordForm"
                          >
                          </ChangePassword>
                        </v-card-text>
                        <v-card-actions class="px-3">
                          <v-spacer></v-spacer>
                          <v-btn color="primary background--text"  @click="reset()">{{$t('screener.btn.cancel')}}</v-btn>
                          <v-btn color="primary background--text"  @click="changePassword()">{{$t('screener.btn.change')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import i18n from "@/i18n";
import Avatar from "vue-avatar";
import rules from "@/validation";
import { mapFields } from "vuex-map-fields";
import VuePhoneNumberInput from "vue-phone-number-input";
import DEFINES from "@/defines";
import { userCountryCode } from "@/mixins/userCountryCode";
import ChangePassword from "@/components/consumer/ChangePassword"

export default {
  name: "ConsumerProfile",
  data() {
    return {
      rules,
      is_editing: false,
      formattedNumber: null,
      Optionaltranslations: {
        countrySelectorLabel: i18n.t("consumer.profile.label.country_code_selector"),
        phoneNumberLabel: i18n.t("screening.register.lable.phone.optional"),
      },
      country_code: DEFINES.DEFAULT_COUNTRY_CODE,
      passworddialog:false,
      password:null,
      confirm_password:null,
      consumerPhone : null,
    };
  },
  components: {
    Avatar,
    VuePhoneNumberInput,
    ChangePassword
  },
  computed: {
    ...mapFields("consumer", {
      consumer_name: "profile.name",
      consumer_email: "profile.email",
      consumer_city: "profile.city",
      consumer_phone: "profile.phone",
    }),
    ...mapState({
      consumer: (state) => state.consumer.profile,
    }),
    ...mapGetters("app", {
      darkMode: "darkMode"
    })
  },
  mixins: [userCountryCode],
  mounted() {
    this.getCountryCode();
    this.setPhone();
  },
  methods: {
    async getCountryCode() {
      this.country_code = await this.getUserCountryCode();
    },
    setPhone(){
      this.consumerPhone = JSON.parse(JSON.stringify(this.consumer_phone));
    },
    setPhoneNumber(payload) {
      if (payload.formattedNumber) {
        this.formattedNumber = payload.formattedNumber;
      }
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      try {
        this.consumer.phone = this.consumer_phone ? this.formattedNumber : null;
        var response = await this.$store.dispatch(
          "consumer/update",
          this.consumer
        );
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.updated"),
          color: "success",
        });
        this.is_editing = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async changePassword() {
      try {
        if (!this.$refs.changePasswordForm.validate()) {
          return false;
        }
        if (this.password != this.confirm_password) {
          throw {
            message: i18n.t("rms.field.entered.passwords.not_matched"),
          };
        }
        await this.$store
          .dispatch("consumer/changePassword", {
            password: this.password,
          })
          .then((response) => {
            this.reset();
            this.$store.dispatch("app/showMessage", {
              message: i18n.t('consumer.profile.password.changed.success.message'),
              color: "success",
            });
          });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    reset(){
      this.passworddialog = false;
      this.$refs.changePasswordForm.reset();
    }
  },
};
</script>
